//Angular
import { Component, Input, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { VisibleState } from 'src/app/app.data';
//App
import { AppAnimations } from 'src/app/_shared/animations';
import { RestResponse } from 'src/app/_shared/models';
import { SettingsService } from '../../../_services/api/settings.service';
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';

@Component({
  animations: [AppAnimations],
  selector: 'create-api-credentials',
  templateUrl: './create-api-credentials.component.html'
})

export class ApiCredentialsCreateComponent implements OnDestroy {
  formSubmitted: boolean = false;
  isFormReady: boolean = true;
  private subs = new Unsubscriber();

  @Input() _visibleState = VisibleState;

  constructor(
    private _router: Router,
    private settingsService: SettingsService
  ) { }

  onSubmit() {
    this.formSubmitted = !this.formSubmitted;
    this.subs.addSub = this.settingsService.createApiKeys().subscribe(
      (res:RestResponse) => {
        this._router.navigate(['/main/settings/advanced/api-credentials']);
      },
      (err:RestResponse) => {
        console.log(err);
        this.formSubmitted = !this.formSubmitted;
      }
    )
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
